import { Component, inject, OnInit } from '@angular/core';
import { Auth } from '../services/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.html',
  styleUrl: './home.css'
})

export class HomeComponent implements OnInit {

  private router = inject(Router);

  constructor( private auth: Auth) {}

  ngOnInit(): void 
  {
    if (!this.auth.isLoggedIn())
    {
      this.router.navigate(['/']);
    }
  };

}
